/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerFindAllProcessingJobsQueryResponse, DocumentsControllerFindAllProcessingJobsPathParams, DocumentsControllerFindAllProcessingJobs401, DocumentsControllerFindAllProcessingJobs403 } from "../../models/documentsController/DocumentsControllerFindAllProcessingJobs";

function getDocumentsControllerFindAllProcessingJobsUrl(id: DocumentsControllerFindAllProcessingJobsPathParams["id"], processingId: DocumentsControllerFindAllProcessingJobsPathParams["processingId"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${id}/processing/${processingId}/jobs` as const }  
  return res
}

/**
 * @summary Get all jobs associated with a processing record
 * {@link /api/v1/documents/:id/processing/:processingId/jobs}
 */
export async function documentsControllerFindAllProcessingJobs(id: DocumentsControllerFindAllProcessingJobsPathParams["id"], processingId: DocumentsControllerFindAllProcessingJobsPathParams["processingId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentsControllerFindAllProcessingJobsQueryResponse, ResponseErrorConfig<DocumentsControllerFindAllProcessingJobs401 | DocumentsControllerFindAllProcessingJobs403>, unknown>({ method : "GET", url : getDocumentsControllerFindAllProcessingJobsUrl(id, processingId).url.toString(), ... requestConfig })  
  return res.data
}